module.exports = __webpack_public_path__ + "img/cpzz9@2x.5039249a.png";